import PageHero from '@/components/PageHero';
import TripleSection from '@/components/TripleSection';
import { useModal } from '@/lib/ModalContext';
import s from '@/components/home.module.css';

export default function Founder() {
  const { setOpen } = useModal();
  return (
    <>
      <PageHero
        eyebrow="The founder"
        title="Built by someone who needed it."
        sub="AVOWAL began as one self-represented litigant's answer to a system priced for firms. Abraham Rosenwald built the operations engine he needed to run his own litigation — then turned it into white-label infrastructure for the attorneys who serve everyone else."
      />

      <TripleSection
        id="origin"
        label="Origin"
        title="The founder is user zero."
        lead="He still runs his own active matters on the same engine attorneys use. There is no deeper form of dogfooding: every deadline the platform tracks, every draft it prepares, every exhibit it assembles exists because a real case demanded it first."
        cards={[
          { num: '/ ORIGIN', title: 'A system priced for firms', body: 'Representing himself, he found the barrier was not the law — it was the mechanical layer of practice. Drafting, deadlines, exhibits, service, dockets. So he built that layer.' },
          { num: '/ DOGFOOD', title: 'Proven on real matters', body: 'The engine is proven on real matters under real court deadlines before any firm touches it. What ships is what survived actual use — not what a roadmap promised.' },
          { num: '/ DISCIPLINE', title: 'Built under scrutiny', body: 'Software built inside live litigation is built knowing a court, opposing counsel, and a regulator may read the output. That standard is in the product, not on a poster.' },
        ]}
      />

      <TripleSection
        id="building"
        label="What he's building toward"
        title="Infrastructure, not a firm."
        lead="Abraham is not an attorney. AVOWAL provides software only — every legal judgment on the platform is rendered by the licensed attorney engaged through it."
        cards={[
          { num: '/ WHITE-LABEL', title: 'Your firm on the front', body: 'Independent attorneys run the platform under their own brand. Clients see the firm, never AVOWAL. Legal fees go to the attorney directly; AVOWAL charges a flat software fee — never a percentage.' },
          { num: '/ SOVEREIGN', title: 'On your own metal', body: 'Custom agents and custom-trained models on hardware the firm owns, offline-capable — work product that never leaves the building. Available as a founding-firm engagement.' },
          { num: '/ THE LINE', title: 'The attorney decides', body: 'ELARIA prepares; the attorney decides and signs. That allocation of judgment is the architecture, and it does not move.' },
        ]}
      />

      <section id="work-with-me">
        <div className="container">
          <span className={s.sectionLabel}>Work with me</span>
          <h2 className={s.sectionTitle}>Three doors. All open.</h2>
          <div className={s.triple}>
            <div className={s.tripleCard}>
              <div className={s.tripleNum}>/ ATTORNEYS</div>
              <h3 className={s.tripleTitle}>Pilot the platform</h3>
              <p className={s.tripleBody}>
                Independent, bar-admitted attorneys can request a walkthrough of the private beta —
                the platform running under your firm&rsquo;s brand.
              </p>
              <button
                className={`${s.btn} ${s.btnPrimary}`}
                style={{ marginTop: '1.25rem' }}
                onClick={() => setOpen('waitlist')}
              >
                Request a walkthrough
              </button>
            </div>
            <div className={s.tripleCard}>
              <div className={s.tripleNum}>/ INVESTORS</div>
              <h3 className={s.tripleTitle}>Investment &amp; acquisition</h3>
              <p className={s.tripleBody}>
                Conversations about investing in or acquiring the platform are welcome. Write
                directly — the founder reads it.
              </p>
              <a className={s.moreLink} style={{ marginTop: '1.25rem' }} href="mailto:aria@arprose.com">
                aria@arprose.com &rarr;
              </a>
            </div>
            <div className={s.tripleCard}>
              <div className={s.tripleNum}>/ PRESS</div>
              <h3 className={s.tripleTitle}>Press &amp; speaking</h3>
              <p className={s.tripleBody}>
                Interviews, panels, and speaking on AI legal operations and access to the courts.
                Same address, same reader.
              </p>
              <a className={s.moreLink} style={{ marginTop: '1.25rem' }} href="mailto:aria@arprose.com">
                aria@arprose.com &rarr;
              </a>
            </div>
          </div>
          <p className={s.sectionLead} style={{ marginTop: '2.5rem', fontSize: '0.85rem' }}>
            AVOWAL is a technology platform; not a law firm; not legal advice.{' '}
            <a href="/legal" className={s.moreLink}>Full legal disclaimers &rarr;</a>
          </p>
        </div>
      </section>
    </>
  );
}
